#import "../../../graphql/fragments/edition-stub-fragment.graphql"

query GetNewsletterEditions(
    $limit: Int!
    $cursor: String
    $newsletterId: ID!
    $isArchived: Boolean
) {
    newsletter(id: $newsletterId) {
        id
        editions(first: $limit, after: $cursor, archived: $isArchived) {
            totalCount
            pageInfo {
                startCursor
                endCursor
                hasNextPage
                hasPreviousPage
            }
            edges {
                cursor
                node {
                    ...EditionStubFragment
                }
            }
        }
    }
}
